<template>
  <div>
    <InteractiveCanvas
      v-if="frame"
      :frame="frame"
      stretch-mode="contain"
      @loaded="interactiveCanvasLoaded"
      @mounted="interactiveCanvasMounted"
      @wheel="handleWheel"
    />
  </div>
</template>

<script>
import { InteractiveCanvas, PolygonTool } from '@dmlnc/hello_world';

export default {
  name: 'InteractiveStatic',
  components: {
    InteractiveCanvas,
  },
  data() {
    return {
      frame: null,
      canvas: null,
    };
  },
  mounted() {
    this.init();
  },
  props: ['interactive'],
  methods: {
    async init() {
      this.frame = this.interactive.frame;
    },
    registerTools(data) {
      this.canvas.toolManager.registerTool('polygon', new PolygonTool(data));
    },
    handleWheel(data) {
      this.canvas.toolManager.panZoom.wheelZoom(data);
    },
    interactiveCanvasMounted(data, render = true) {
      data.controls = {
        setTool: function () {},
      };
      this.canvas = data;
      this.registerTools(data);

      if (render) {
        this.render();
      }
    },
    render() {
      this.canvas.functions.render();
      this.frame.layers.forEach((layer) => {
        layer.state.value = 'active';
        layer.tool.applyLayerStyle(
          layer.shape,
          layer.options.active,
          layer.visible
        );
      });
    },
    interactiveCanvasLoaded(data, render = true) {
      this.canvas = data;
      if (render) {
        this.render();
      }
    },
  },
};
</script>

<style lang="scss">
@import '@dmlnc/hello_world/styles.scss';
</style>
